module.exports = __webpack_public_path__ + "static/media/1-copy.6994e5d0.svg";